import { lockSelectToWidestOption, search } from "algolia-instant-search";

const { connectHitsPerPage } = instantsearch.connectors;

if (!customElements.get("algolia-hits-per-page")) {
  class AlgoliaHitsPerPage extends HTMLElement {
    hitsPerPage = 12;

    connectedCallback() {
      this.selectElements();

      const pageSize = this.getDefaultPageSize();
      this.hitsPerPage = pageSize;

      const customHitsPerPage = connectHitsPerPage(
        this.renderHitsPerPage.bind(this),
      );

      search.addWidgets([
        customHitsPerPage({
          container: this.content,
          items: [
            { label: `${pageSize} Items`, value: pageSize, default: true },
            { label: `${pageSize * 2} Items`, value: pageSize * 2 },
            { label: `${pageSize * 4} Items`, value: pageSize * 4 },
          ],
        }),
      ]);
    }

    getDefaultPageSize() {
      const basePageSize = 12;
      const productsPerRow = this.getProductsPerRow();

      return Math.ceil(basePageSize / productsPerRow) * productsPerRow;
    }

    getProductsPerRow() {
      const grid = this.closest("main-collection, main-search")?.querySelector(
        "#main-product-grid",
      );
      if (!grid) return 1;

      const responsiveClasses = [
        [1500, "xxl-flex-"],
        [1200, "xl-flex-"],
        [992, "lg-flex-"],
        [750, "md-flex-"],
        [575, "sm-flex-"],
        [0, "flex-"],
      ];

      const activePrefix = responsiveClasses.find(
        ([minWidth]) => window.innerWidth >= minWidth,
      )[1];
      const columnClass = Array.from(grid.classList).find((className) => {
        const value = className.slice(activePrefix.length);
        return className.startsWith(activePrefix) && /^\d+$/.test(value);
      });
      const columns = Number.parseInt(
        columnClass?.slice(activePrefix.length),
        10,
      );

      return Number.isFinite(columns) && columns > 0 ? columns : 1;
    }

    selectElements() {
      this.selectTemplate = this.querySelector("template#hits-per-page");
      this.content = this.querySelector("#content");
    }

    renderHitsPerPage(renderOptions, isFirstRender) {
      const { items, refine, widgetParams } = renderOptions;

      if (isFirstRender) {
        const selectClone = this.selectTemplate.content.cloneNode(true);
        widgetParams.container.appendChild(selectClone);
      }

      const select = widgetParams.container.querySelector("select");
      select.innerHTML = "";

      items.forEach((item) => {
        const optionElement = document.createElement("option");
        optionElement.value = item.value;
        optionElement.textContent = item.label;
        optionElement.selected = item.isRefined;
        select.appendChild(optionElement);
      });

      lockSelectToWidestOption(select);

      select.removeEventListener("change", this.onChange);
      this.onChange = (e) => {
        const value = e.target.value;
        this.hitsPerPage = value;
        refine(Number(value));
      };
      select.addEventListener("change", this.onChange);
    }
  }
  customElements.define("algolia-hits-per-page", AlgoliaHitsPerPage);
}
